export const switchCustomTheme = {
  bg: 'palette.surface.4',
  borderColor: 'palette.tertiary.10',
  borderRadius: '6px',
  borderWidth: '1px',
};
